import http from 'http';
import https from 'https';

export const apiHttpAgent = new http.Agent({keepAlive: true});
export const apiHttpsAgent = new https.Agent({
  rejectUnauthorized: false,
  keepAlive: true,
});

export const kakaoHttpAgent = new http.Agent({keepAlive: true});
export const kakaoHttpsAgent = new https.Agent({
  keepAlive: true,
});

export const tckHttpAgent = new http.Agent({keepAlive: true});
export const tckHttpsAgent = new https.Agent({keepAlive: true});

export const kakaoBankHttpAgent = new http.Agent({keepAlive: true});
export const kakaoBankHttpsAgent = new https.Agent({keepAlive: true});
